import Vue from 'vue'
import Vuex from 'vuex'

import auth from '@/store/modules/auth'
import tools from '@/store/modules/tools'
import task from '@/store/modules/task'
import process from '@/store/modules/process'
import report from '@/store/modules/report'
import data from '@/store/modules/data'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    auth: {
      namespaced: true,
      state: auth.state,
      mutations: auth.mutations,
      actions: auth.actions,
      getters: auth.getters,
    },
    tools: {
      namespaced: true,
      state: tools.state,
      mutations: tools.mutations,
      actions: tools.actions,
      getters: tools.getters,
    },
    task: {
      namespaced: true,
      state: task.state,
      mutations: task.mutations,
      actions: task.actions,
      getters: task.getters,
    },
    process: {
      namespaced: true,
      state: process.state,
      mutations: process.mutations,
      actions: process.actions,
      getters: process.getters,
    },
    report: {
      namespaced: true,
      state: report.state,
      mutations: report.mutations,
      actions: report.actions,
      getters: report.getters,
    },
    data: {
      namespaced: true,
      state: data.state,
      mutations: data.mutations,
      actions: data.actions,
      getters: data.getters,
    },
  },
})



// WEBPACK FOOTER //
// ./src/store/index.js